<script setup>
import DefaultLayout from './DefaultLayout.vue';
import AuthLayout from './AuthLayout.vue';
import SimpleLayout from './SimpleLayout.vue';

const route = useRoute();

const layout = shallowRef(null);

const layouts = {
	Default: DefaultLayout,
	Auth: AuthLayout,
	Simple: SimpleLayout,
};

const renderComponent = (layoutName = 'Default') => {
	layout.value = layouts[layoutName];
};

watch(() => route.meta.layout, renderComponent, { immediate: true });
</script>

<template>
	<component :is="layout">
		<slot />
	</component>
</template>
